/** 미로그인 → 로그인 리다이렉트 후 복귀할 내부 경로 (오픈 리다이렉트 방지) */

const PUBLIC_PATHS = new Set([
  '/',
  '/login',
  '/test-login',
  '/register',
  '/invitation-register',
  '/privacy-policy',
  '/terms-of-service',
]);

function isPublicPath(pathname) {
  if (!pathname) {
    return true;
  }
  if (PUBLIC_PATHS.has(pathname)) {
    return true;
  }
  return pathname.startsWith('/consent-request/');
}

/** returnTo 값이 같은 origin 내부 경로인지 검증 */
export function isSafeReturnTo(returnTo) {
  if (returnTo == null || typeof returnTo !== 'string') {
    return false;
  }
  const trimmed = returnTo.trim();
  if (!trimmed.startsWith('/') || trimmed.startsWith('//')) {
    return false;
  }
  if (trimmed.includes('://') || trimmed.includes('\\')) {
    return false;
  }
  const pathname = trimmed.split('?')[0].split('#')[0];
  if (isPublicPath(pathname)) {
    return false;
  }
  return true;
}

export function getReturnToFromSearch(search) {
  if (!search) {
    return null;
  }
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const raw = params.get('returnTo');
  if (!raw || !isSafeReturnTo(raw)) {
    return null;
  }
  return raw;
}

/** 보호된 경로에서 로그인으로 보낼 URL (returnTo 쿼리 포함) */
export function buildLoginUrlWithReturnTo(pathname, search = '') {
  const returnTo = `${pathname || ''}${search || ''}`;
  if (!isSafeReturnTo(returnTo)) {
    return '/login';
  }
  return `/login?returnTo=${encodeURIComponent(returnTo)}`;
}

export function resolvePostLoginPath(search) {
  return getReturnToFromSearch(search) || '/dashboard';
}
